/** @format */

import styled from 'styled-components';

/** @format */
export const PopupContent = styled.div``;
